/** @jsx jsx */
import { jsx } from '@emotion/core'
import ContribMenu from './ContribMenu'
import R from 'ramda'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux'
import ContribView from './ContribView'
import { getContribKeys, getCAContribKeys, getMetrics } from '../selectors'
import { Content, FullHeightSizer } from 'core/screen-util'
// const Container = styled.div`
//   padding-left: 1em;
//   padding-right: 1em;
// `

// const specToRoute = spec => {
//   const { group, id } = spec
//   return (
//     <Route
//       key={`${group.id}-${id}-content`}
//       path={`/scatter/${group}/${id}`}
//       render={_ => <Scatter group={group} id={id} spec={spec} />}
//     />
//   )
// }

const toContribRoute = isCa => ({ id, display }) => (
  <Route
    key={`conrib${id}`}
    kpi={id}
    exact
    path={`/contrib/${id}`}
    render={() => <ContribView display={display} kpi={id} isCa={isCa} />}
  />
)

const ContribContainer = ({ metrics, contribKeys, caContribKeys }) => {
  const toRoutes = isCa =>
    R.compose(
      R.map(toContribRoute(isCa)),
      R.filter(v => v),
      R.map(id => metrics[id])
    )

  return (
    <FullHeightSizer heightOffset={170}>
      {({ height }) => (
        <Content css={{ height: height - 20, paddingTop: '10px', minHeight: height }}>
          <ContribMenu
            style={{
              position: 'absolute',
              right: '15px',
              zIndex: '1000',
              maxHeight: height - 40,
              overflowY: 'auto',
            }}
          />
          {toRoutes(false)(contribKeys)}
          {toRoutes(true)(caContribKeys)}
        </Content>
      )}
    </FullHeightSizer>
  )
}

const mapStateToProps = state => ({
  metrics: getMetrics(state),
  contribKeys: getContribKeys(state),
  caContribKeys: getCAContribKeys(state),
})

export default connect(mapStateToProps)(ContribContainer)
